var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29485 9.61882C1.14268 9.37786 1.06659 9.25738 1.024 9.07155C0.992002 8.93197 0.992002 8.71184 1.024 8.57225C1.06659 8.38642 1.14268 8.26595 1.29485 8.02499C2.5524 6.03377 6.29559 1 12 1C17.7044 1 21.4476 6.03377 22.7051 8.02499C22.8573 8.26594 22.9334 8.38642 22.976 8.57225C23.008 8.71184 23.008 8.93197 22.976 9.07155C22.9334 9.25738 22.8573 9.37786 22.7051 9.61882C21.4476 11.61 17.7044 16.6438 12 16.6438C6.29559 16.6438 2.5524 11.61 1.29485 9.61882Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.1741C13.8514 12.1741 15.3522 10.6733 15.3522 8.8219C15.3522 6.97051 13.8514 5.46966 12 5.46966C10.1486 5.46966 8.64776 6.97051 8.64776 8.8219C8.64776 10.6733 10.1486 12.1741 12 12.1741Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-On.c19f4c449df6e67f8f493bfb34f6b828.svg";
export { ForwardRef as ReactComponent };